module.exports = __webpack_public_path__ + "guide-notice01.7fe14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/guide-notice01.svg
// module id = ./src/_asset/sources/assets/images/@svg/guide-notice01.svg
// module chunks = main